import { IconBtn } from 'ctls/inputs/IconBtn';
import styled from 'styled-components';

export const DlgTitleWithCloseBtn = ({ title, onClose }: { title: string; onClose: () => void }) => {
  return (
    <DlgTitle>
      {title}
      <CloseBtn btnType="close" onClick={onClose} />
    </DlgTitle>
  );
};

const DlgTitle = styled.div`
  font-size: 2.4rem;
  font-weight: 700;
  color: #2a2c2f;
  padding: 3.6rem 3.2rem 0 3.2rem;
`;

const CloseBtn = styled(IconBtn)`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  width: 2.4rem;
  height: 2.4rem;
`;
